'use client'
const PUBLIC_PROJECT_LIVE_ENVIRONMENT_ID = '2762a57b-faa4-41ce-9f16-abff9300e2c9';
/**
 * These values will override undefined values in the dynamic context settings.
 */
const defaultDynamicSettings = {
    appLogoUrl: 'https://demo.dynamic.xyz/assets/dynamic-logo.svg',
    appName: 'Dynamic Example',
    debugError: false,
    deepLinkPreference: 'native',
    detectNewWalletsForLinking: false,
    displaySiweStatement: true,
    enableConnectOnlyFallback: false,
    enableVisitTrackingOnConnectOnly: true,
    initialAuthenticationMode: 'connect-and-sign',
    logLevel: 'WARN',
    shadowDOMEnabled: true,
    showLockedWalletView: false,
    tokensFilter: (tokens) => tokens,
    useMetamaskSdk: true,
};

export { PUBLIC_PROJECT_LIVE_ENVIRONMENT_ID, defaultDynamicSettings };
